export function isDuplicateGuardBlockPayload(payload) {
  if (!payload) return false;
  const code = payload.errorCode;
  const blocked =
    code === "REDEMPTION_WITHIN_24_HOURS" ||
    code === "DUPLICATE_SAME_VISIT_PRODUCT" ||
    code === "DUPLICATE_SAME_VISIT_CORE" ||
    code === "MAIN_AND_HAND_POLISH_CONFLICT";
  return blocked && payload.data?.allowAdminOverride === true;
}

export function duplicateGuardModalTitle(errorCode) {
  if (errorCode === "DUPLICATE_SAME_VISIT_PRODUCT") {
    return "Duplicate redemption for this visit";
  }
  if (errorCode === "DUPLICATE_SAME_VISIT_CORE") {
    return "Core services cannot be redeemed on the same day";
  }
  if (errorCode === "MAIN_AND_HAND_POLISH_CONFLICT") {
    return "Main wash and Hand Polish conflict";
  }
  return "24-hour redemption cooldown";
}

/** Admin label: Product type. API field: productType. */
export const PRODUCT_TYPE_OPTIONS = [
  { value: "core", label: "Core" },
  { value: "addon", label: "Add-on" },
  { value: "not_applicable", label: "Not applicable" },
];

export function readProductTypeFromProduct(product) {
  const raw = product?.productType ?? product?.visitRole;
  return normalizeProductTypeValue(raw);
}

export function normalizeProductTypeValue(productType) {
  if (productType === "extra") return "addon";
  return productType || "not_applicable";
}

export function formatProductTypeLabel(productOrValue) {
  const value =
    typeof productOrValue === "object"
      ? readProductTypeFromProduct(productOrValue)
      : normalizeProductTypeValue(productOrValue);
  const opt = PRODUCT_TYPE_OPTIONS.find((o) => o.value === value);
  return opt ? opt.label : "Not applicable";
}
